"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchStatTourStepsViewThunk = exports.fetchStatTourViewThunk = exports.fetchStatCohortPaycvThunk = exports.fetchStatBaseThunk = void 0;
const axios_1 = __importDefault(require("src/utils/axios"));
const actions_1 = require("./actions");
const actions_2 = require("src/stores/exportedStore/loader/actions");
const fetchStatBaseThunk = ({ date_from, date_to, period }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .get("/api/v1/app/stat/base/", { params: { date_from, date_to, period } })
        .then((res) => {
        dispatch((0, actions_1.setStatBase)(res.data));
    })
        .catch(console.log)
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
});
exports.fetchStatBaseThunk = fetchStatBaseThunk;
const fetchStatCohortPaycvThunk = ({ date_from, date_to }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .get("/api/v1/app/stat/cohort/paycv/", { params: { date_from, date_to } })
        .then((res) => {
        dispatch((0, actions_1.setStatCohortPaycv)(res.data));
    })
        .catch(console.log)
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
});
exports.fetchStatCohortPaycvThunk = fetchStatCohortPaycvThunk;
const fetchStatTourViewThunk = ({ date_from, date_to }) => (dispatch) => {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .get("/api/v1/app/stat/tour/", { params: { date_from, date_to } })
        .then((res) => {
        dispatch((0, actions_1.setStatTour)(res.data));
    })
        .catch(console.log)
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
};
exports.fetchStatTourViewThunk = fetchStatTourViewThunk;
const fetchStatTourStepsViewThunk = ({ date_from, date_to, tour, finished }) => (dispatch) => {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .get(`/api/v1/app/stat/tour/${tour}/steps/`, { params: { date_from, date_to, finished } })
        .then((res) => {
        dispatch((0, actions_1.setStatTourSteps)(res.data));
    })
        .catch(console.log)
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
};
exports.fetchStatTourStepsViewThunk = fetchStatTourStepsViewThunk;
